import styled, { css } from 'styled-components'
import { forLargeScreenUp, forMediumScreenUp } from '../utils/style'

export const Container = styled.div`
  margin: 0 auto;
  margin-top: var(--headerHeight);
  padding: var(--spacing-3);

  ${forMediumScreenUp(css`
    padding: var(--spacing-6);
  `)}

  ${forLargeScreenUp(css`
    max-width: var(--layout-width);
    display: grid;
    grid-template-columns: auto 240px;
    gap: var(--spacing-20);
  `)}

  main,
  aside {
    padding-top: var(--spacing-8);
  }
`
